import { AppBar, Box, IconButton, Stack, Toolbar } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import { com } from '@eidu/web'
import { useCompactNavigation } from './CompactNavigationContext'
import ActionsMenu from './ActionsMenu'
import ImpersonationChip from './ImpersonationChip'
import { Theme, getThemeConfig } from '../../ui/theme/themeConfig'
import EntityId = com.eidu.sharedlib.entity.EntityId

const DefaultLogo = () => (
  <img src={getThemeConfig('default').logoSrc} className="appBarIcon" alt="" style={{ height: 24 }} />
)

const KenyaMoeLogo = () => <img src={getThemeConfig('kenyaMoe').logoSrc} className="appBarIcon" alt="" />

const AppBarLogo = ({ theme }: { theme: Theme }) => (theme === 'kenyaMoe' ? <KenyaMoeLogo /> : <DefaultLogo />)

export type TopAppBarProps = {
  userEntityId: EntityId | undefined
  signOut?: () => void
  theme?: Theme
}

const TopAppBar = ({ userEntityId, signOut, theme = 'default' }: TopAppBarProps) => {
  const { isCompact, toggleDrawer } = useCompactNavigation()

  return (
    <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Toolbar>
        <Stack
          direction="row"
          sx={{
            alignItems: 'center',
            width: '100%',
            display: 'grid',
            gridTemplateColumns: isCompact ? '1fr auto 1fr' : '1fr 1fr',
          }}
        >
          <Stack direction="row" sx={{ alignItems: 'center', justifySelf: 'start' }}>
            {isCompact ? (
              <IconButton color="inherit" edge="start" aria-label="Toggle navigation menu" onClick={toggleDrawer}>
                <MenuIcon />
              </IconButton>
            ) : (
              <AppBarLogo theme={theme} />
            )}
          </Stack>
          {isCompact && (
            <Box sx={{ justifySelf: 'center', display: 'flex', alignItems: 'center' }}>
              <AppBarLogo theme={theme} />
            </Box>
          )}
          <Stack direction="row" sx={{ alignItems: 'center', justifySelf: 'end' }}>
            <ImpersonationChip />
            <ActionsMenu userEntityId={userEntityId} signOut={signOut} />
          </Stack>
        </Stack>
      </Toolbar>
    </AppBar>
  )
}

export default TopAppBar
